var tabs = function () {

  var publicMethods = {};

  var elements = document.querySelectorAll('.js-tabs');

  publicMethods.init = function() {

    if (!elements.length) return;
    
    for (var i = 0; i < elements.length; i++) {
			
			(function (i) { setup(elements[i]); })(i);
		
		}

  };

  function setup(element) {

		var title = element.querySelector('.js-tabs-title');
		var menu = element.querySelector('.js-tabs-menu');
		var links = element.querySelectorAll('.js-tabs-link');
		var tabs = element.querySelectorAll('.js-tabs-tab');

		for (var i = 0; i < links.length; i++) {
			
			(function (i) {
				
				if (links[i].classList.contains('active')) { title.innerHTML = links[i].innerHTML; }
				links[i].addEventListener('click', function() { handleLinkClick(links[i], links, title, menu, tabs, element); });

			})(i);
		
		}

		title.addEventListener('click', function(e) {
			
			title.classList.toggle('active');

			var menuDisplayAttribute = title.classList.contains('active') ? 'block' : 'none';

			menu.style.display = menuDisplayAttribute;

			e.preventDefault();

		});

  };

	function handleLinkClick(link, links, title, menu, tabs, element) {

		var category = link.getAttribute('data-category');
		
		title.innerHTML = link.innerHTML;
		title.classList.remove('active');

		menu.style.display = 'none';

		if (category === '') {
			
			showAll(tabs);
		
		} else {

			hideAll(tabs);

			var activeTabs = element.querySelectorAll('[data-categories*="' + category + '"]');
			showAll(activeTabs);

			for (var i = 0; i < links.length; i++) {
			
				(function (i) { links[i].classList.remove('active'); })(i);
			
			}

			link.classList.add('active');

		}

	};

	function showAll(elements) {

		for (var i = 0; i < elements.length; i++) {
			
			(function (i) { elements[i].style.display = 'inline-block'; })(i);
		
		}

	};

	function hideAll(elements) {

		for (var i = 0; i < elements.length; i++) {
			
			(function (i) { elements[i].style.display = 'none'; })(i);
		
		}

	};

  return publicMethods;

}();

tabs.init();
